import React from "react";
import Tooltip from "@mui/material/Tooltip";
import WarningIcon from "@mui/icons-material/Warning";

export function AlertIcon({
  device_alert,
  device_alert_text,
  patient_alert,
  patient_alert_text,
}) {
  const DeviceAlert = function () {
    return device_alert ? (
      <div style={{ whiteSpace: "pre-line", margin: "10px" }}>
        {device_alert_text}
      </div>
    ) : null;
  };

  const PatientAlert = function () {
    return patient_alert ? (
      <div style={{ whiteSpace: "pre-line", margin: "10px" }}>
        {patient_alert_text}
      </div>
    ) : null;
  };
  const html = (
    <>
      <DeviceAlert />
      <PatientAlert />
    </>
  );
  return device_alert || patient_alert ? (
    <Tooltip
      style={{ fontSize: "18px", width: "50px" }}
      title={html}
      placement="bottom"
    >
      <WarningIcon />
    </Tooltip>
  ) : null;
}
